import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatoFecha'
})
export class FormatoFechaPipe implements PipeTransform {

  transform(value: Date): any {
    let fecha = value.toISOString();

    let dia = fecha.substring(8,10);
    let mes = this.labelMes(fecha.substring(5,7));
    let año = fecha.substring(0,4);

    fecha = dia + "-" + mes + "-" + año;

    return fecha;
  }

  labelMes = (mes) => {
    let meses = [
        'Ene.',
        'Feb.',
        'Mar.',
        'Abr.',
        'May.',
        'Jun.',
        'Jul.',
        'Ago.',
        'Sep.',
        'Oct.',
        'Nov.',
        'Dic.'
    ];
    return meses[mes - 1];
}

  
  


}
